// This checks if the main logic of this script has already been run.
// If the 'window.cartTestimonialObserverInitialized' flag is true, it stops immediately.
if (!window.cartTestimonialObserverInitialized) {

  // --- SET THE FLAG ---
  // Set a global flag to 'true' immediately. This prevents this block
  // from ever running again on this page, even if the script is re-injected.
  window.cartTestimonialObserverInitialized = true;

  /**
   * Initializes the Swiper slider for the cart testimonials.
   */
  function initializeCartTestimonialSlider() {
    const testimonialSwiperElement = document.querySelector('.cart-testimonial__swiper');

    // Check if the element exists and hasn't been initialized by Swiper yet
    if (testimonialSwiperElement && !testimonialSwiperElement.classList.contains('swiper-initialized')) {
      new Swiper(testimonialSwiperElement, {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1,
        navigation: {
          nextEl: '.cart-testimonial .swiper-button-next',
          prevEl: '.cart-testimonial .swiper-button-prev',
        },
      });
    }
  }

  /**
   * A function to handle DOM updates, with a delay to ensure content is rendered.
   */
  function handleCartUpdate() {
    setTimeout(initializeCartTestimonialSlider, 100);
  }

  // Run once on initial page load
  document.addEventListener('DOMContentLoaded', initializeCartTestimonialSlider);

  // The MutationObserver is the most reliable way to detect when the
  // cart drawer content is dynamically added or changed by AJAX.
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        if (document.querySelector('.cart-testimonial__swiper')) {
          handleCartUpdate();
          break;
        }
      }
    }
  });

  // Start observing the entire document for changes.
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}